import { primaryActive, tableText } from "../../hooks/use-map-theme-styles";

const ComparisonIcon = ({ isActive, size, inactiveColor }: { isActive?: boolean; size?: string; inactiveColor?: string }) => {
	const color = isActive ? primaryActive : inactiveColor || tableText;

	return (
		<svg xmlns="http://www.w3.org/2000/svg" width={size ? size : "24"} height={size ? size : "24"} viewBox="0 0 24 24" fill="none">
			<mask id="path-1-inside-1_4005_2801" fill="white">
				<rect x="2" y="3" width="9" height="8" rx="1" />
			</mask>
			<rect x="2" y="3" width="9" height="8" rx="1" stroke={color} stroke-width="4" mask="url(#path-1-inside-1_4005_2801)" />
			<rect x="2.5" y="14.5" width="8" height="1" stroke={color} />
			<rect x="2.5" y="19.5" width="8" height="1" stroke={color} />
			<mask id="path-4-inside-2_4005_2801" fill="white">
				<rect x="13" y="3" width="9" height="8" rx="1" />
			</mask>
			<rect x="13" y="3" width="9" height="8" rx="1" stroke={color} stroke-width="4" mask="url(#path-4-inside-2_4005_2801)" />
			<rect x="13.5" y="14.5" width="8" height="1" stroke={color} />
			<rect x="13.5" y="19.5" width="8" height="1" stroke={color} />
		</svg>
	);
};

export default ComparisonIcon;
